import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Popover } from 'foundations-components/transitional/components/Popover';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import useCampaignToAutoSelectPopover from '../hooks/useCampaignToAutoSelectPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignToAutoSelectPopover(_ref) {
  let {
      children
    } = _ref,
    hookParams = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isPopoverOpen,
    onYes,
    onNo
  } = useCampaignToAutoSelectPopover(hookParams);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    renderContent: isIntersecting => /*#__PURE__*/_jsx(Popover, {
      inlineSize: "320px",
      open: isIntersecting && isPopoverOpen,
      content: {
        body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "campaignSelect.campaignAutoSelectPopover.text"
        }),
        footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: onYes,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaignSelect.campaignAutoSelectPopover.buttonYes"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "tertiary-light",
            onClick: onNo,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaignSelect.campaignAutoSelectPopover.buttonNo"
            })
          })]
        })
      },
      children: children
    })
  });
}